var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "30px",
    viewBox: "0 0 90 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sign-Up/Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3A-Partner-Portal/Member-Login",
    transform: "translate(-217, -258)",
    fill: "#BFBFBF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(100, 231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M178.927239,27.848428 C179.19579,27.8500171 179.460283,27.91411 179.699772,28.0356309 L205.163622,40.9564569 C206.015603,41.3887679 206.355813,42.4298925 205.923502,43.2818738 C205.754134,43.615657 205.481076,43.8855034 205.145312,44.0509094 L179.530341,56.6694938 C178.673303,57.0916922 177.636277,56.7391854 177.214079,55.8821479 C177.095401,55.6412379 177.034442,55.3760051 177.036031,55.1074541 L177.097,44.837 L119.985207,44.4999562 C118.60452,44.4917865 117.491874,43.3658951 117.500044,41.9852074 C117.508214,40.6045197 118.634105,39.491874 120.014793,39.5000438 L177.126,39.837 L177.187152,29.5680438 C177.192508,28.6629558 177.892005,27.9243307 178.777944,27.8538945 Z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow.c277860b34a24c30697375e5011ebfb3.svg";